import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/subjectsCategory'
import {combineEpics} from 'redux-observable'

export const subjectCategoryEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)